// TODO: pass relevant vars to parseTemplate()
import React, { useContext } from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import WhatsAppShare from "@components/CMS/WhatsAppShare";
import { isCLApp } from "@config";
import metrics from "@constants/metrics";
import {
  CMS_ENTITY_TYPE,
  CUSTOMER_PAGE,
} from "../../constants/analyticsEventsCT";
import parseTemplate from "../../utils/parseTemplate";
import { shareOnWhatsapp } from "../../utils/shareEntity";
import { CustomerContext } from "@screens/CustomerProfile";
import analytics from "@services/analytics";
const MessageCLBanner = (props) => {
  const {
    title_ref,
    cl_title,
    cx_title,
    cms_item_id,
    sub_type,
    sharingTemplate: { image_link: sharing_image_link = "", template = "" },

    trackEvent = () => {},
    fromCX_Detail = false,
    fromBannerListHorizontal = false,
    onlyChild = false,
  } = props;
  const customerConsumer = useContext(CustomerContext);
  // const [multiLined, setMultiLined] = useState(false);
  const multiLined = true;

  const parsedText = parseTemplate(
    template,
    customerConsumer &&
      customerConsumer.currentUser &&
      customerConsumer.currentUserPhone
      ? {
          currentUser: customerConsumer.currentUser,
          currentUserPhone: customerConsumer.currentUserPhone,
        }
      : {},
  );
  const ctaText = isCLApp ? cl_title : cx_title;

  // const _onTextLayout = useCallback((e) => {
  //   setMultiLined(e.nativeEvent.lines.length >= 4);
  // }, []);

  const _onShare = () => {
    shareOnWhatsapp({
      message: parsedText,
      image: sharing_image_link.trim(),
      phoneNumber: customerConsumer?.currentUserPhone,
    });
    if (fromCX_Detail) {
      analytics.trackEvent(CUSTOMER_PAGE.CX_DETAIL_PLACE_ORDER, {
        cx_id: customerConsumer.cx_id,
        message: parsedText,
      });
    }
    if (typeof trackEvent === "function") {
      const eventPayload = {
        cms_item_id,
        cms_title: title_ref,
        banner_type: sub_type,
      };

      trackEvent(CMS_ENTITY_TYPE.WA_MSG_BANNER, eventPayload);
    }
  };

  return (
    <View
      style={[
        styles.grayContainer,
        fromBannerListHorizontal
          ? styles.insideListStyles
          : styles.outsideListStyles,
        // eslint-disable-next-line react-native/no-inline-styles
        {
          width: fromBannerListHorizontal
            ? onlyChild
              ? metrics.screenWidth - 30
              : metrics.screenWidth - 42
            : "auto",
        },
      ]}
    >
      <View
        style={[
          styles.whiteContainerBorder,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            flex: multiLined ? 1 : 0,
            borderRadius: !multiLined ? 8 : 15,
          },
        ]}
      >
        <View
          style={[
            styles.whiteContainerBorderRadiusFix,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              flex: multiLined ? 1 : 0,
              borderRadius: !multiLined ? 8 : 15,
            },
          ]}
        >
          <ScrollView
            nestedScrollEnabled={true}
            contentContainerStyle={styles.whiteContainer}
          >
            <Text style={styles.msg}>{parsedText}</Text>
          </ScrollView>
        </View>
      </View>
      <WhatsAppShare
        textStyles={styles.shareButtonFont}
        wrapperStyles={styles.shareButton}
        onShare={_onShare}
        caret={false}
        title={ctaText}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  grayContainer: {
    marginHorizontal: 15,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: 15,
    padding: 10,
    height: 180,
    justifyContent: "space-between",
    maxWidth: 600,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
  },
  whiteContainerBorder: {
    borderWidth: 1,
    borderRadius: 15,
    borderColor: "rgba(0,0,0,0.1)",
  },
  whiteContainerBorderRadiusFix: {
    borderRadius: 15,
    borderColor: "white",
    backgroundColor: "white",
    borderWidth: 4,
    flex: 1,
  },
  whiteContainer: {
    borderRadius: 15,
    backgroundColor: "transparent",
    overflow: "hidden",
    borderColor: "white",
  },
  msg: {
    flex: 1,
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 16,
    lineHeight: 24,
    color: "rgba(0,0,0,1)",
    padding: 6,
  },
  shareButtonFont: { fontFamily: "Mukta-SemiBold", fontSize: 16 },
  shareButton: {
    backgroundColor: "#23CF5F",
    paddingHorizontal: 15,
    marginLeft: "auto",
    borderRadius: 6,
    marginTop: 10,
    width: "auto",
    paddingVertical: 20,
    minWidth: 137,
  },
  insideListStyles: {
    marginLeft: 0,
    marginRight: 10,
    marginVertical: 0,
  },
  outsideListStyles: {
    marginLeft: 15,
    marginRight: 15,
    marginTop: 10,
    marginBottom: 12,
  },
});

export default MessageCLBanner;
